<template>
  <van-popup v-model="showDateSelect" position="bottom" class="main" @closed="onClosed">
    <van-nav-bar
      class="main"
      :title="'选择'+selectList.length+'/'+needNum+'名出行人员'"
      left-text="返回"
      right-text="确认"
      left-arrow
      @click-left="onClosed"
      @click-right="onConfirm"
    />
    <van-button type="default" size="large" class="addButton" :color="GetColorMain()" plain @click="onAddNewContact">+新增</van-button>
    <div class="customerRects">
      <van-checkbox-group v-model="selectList" :max="needNum">
        <div v-for="item in dateList" :key="item.customerLogId" class="lines">
          <div class="leftIcon">
            <i class="iconfont iconeditrect" @click="onEditContart(item.customerLogId)" />
          </div>
          <div class="data">
            <div class="name"> {{ item.loaclName }}/{{ item.lastName }}{{ item.firstName }}</div>
            <div class="info"> 区域:{{ item.zipString }} </div>
            <div class="info2">
              <span v-if="item.birthday">生日 {{ formatDate(item.birthday,"yyyy/MM/dd") }}</span>
              <span v-if="item.birthday && item.phone">/</span>
              <span v-if="item.phone">手机号 {{ item.phone }}</span>
            </div>
          </div>
          <div class="rigthSelect">
            <van-checkbox :name="item.customerLogId" :disabled="item.disabled" shape="square" icon-size="1.4em" :checked-color="GetColorMain()" />
          </div>
        </div>
      </van-checkbox-group>
    </div>
    <updateCustomerInfo v-model="customerOrderId" show-type="easy" @reload="onLoadList" />
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import { MyNotify, formatDate, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { Button, Popup, Checkbox, CheckboxGroup, NavBar } from 'vant'
import updateCustomerInfo from '@/components/updateCustomerInfo'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    updateCustomerInfo
  },
  props: {
    // eslint-disable-next-line
    disabledList:Array,
    // eslint-disable-next-line
    value: Number,
    // eslint-disable-next-line
    list:Array
  },
  data() {
    return {
      showDateSelect: false,
      needNum: 0,
      loading: true,
      dateList: [],
      selectList: [],
      selectListAdd: [],
      disabledSelectList: [],
      customerOrderId: undefined
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.needNum = newValue
        this.showDateSelect = true
        this.onLoadList(() => {

        })
      } else {
        this.needNum = 0
        this.showDateSelect = false
      }
    },
    list(newValue) {
      console.log('SelectContacts,List', newValue)
      this.selectListAdd = newValue
      this.onDoProList()
    },
    disabledList(newValue) {
      this.disabledSelectList = newValue
      this.onDoProList()
    }
  },
  created() {

  },
  methods: {
    formatDate,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onDoProList() {
      this.selectList = []
      this.selectListAdd.forEach(item => {
        this.selectList.push(item)
      })
      this.disabledSelectList.forEach(item => {
        this.selectList.push(item)
      })

      console.log('禁用列表', this.disabledSelectList)
      this.dateList = JSON.parse(JSON.stringify(this.dateList))
      this.dateList.forEach(item => {
        item.disabled = false
        if (this.disabledSelectList.filter(id => id === item.customerLogId).length > 0) {
          item.disabled = true
        }
      })
      console.log('输出列表', this.dateList)
    },
    onLoadList(callback) {
      request({
        url: '/StoreHelper/getUserCustomerSimpleInfoList',
        method: 'post'
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.dateList = response.data
        this.onDoProList()
        if (callback) {
          callback()
        }
      })
    },
    onClosed() {
      this.$emit('input', 0)
    },
    onConfirm() {
      if (this.selectList.length !== this.needNum) {
        MyNotify('info', '请选择' + this.needNum + '名出行人员')
        return
      }
      var result = []
      this.dateList.forEach(item => {
        this.selectList.forEach(id => {
          if (item.customerLogId === id) {
            result.push(item)
          }
        })
      })
      this.$emit('select', result)
      this.$emit('input', 0)
    },
    onAddNewContact() {
      //  this.$router.push('/my/customer?type=simple')
      this.customerOrderId = 0
    },
    onEditContart(customerId) {
      this.customerOrderId = customerId
    }

  }
}
</script>

<style scoped>
.main{
  background-color: #F1F1F1;
}
.customerRects{
  height: 20em;
  overflow-y:scroll;
  overflow-x: hidden;
   background-color: #fff;
}
.customerRects .lines{
  position: relative;
  height: 4em;
  padding: 0.5em 0;
}
.customerRects .lines .leftIcon{
  position: absolute;
  left: 0.8em;
  top: 0.5em;
  bottom: 0;
  width: 2em;
  line-height: 4em;
  color: #999;

}
.customerRects .lines .leftIcon i{
  font-size: 1.3em;
}
.customerRects .lines .rigthSelect{
   position: absolute;
  top: 1.8em;
  bottom: 0;
  right: 0.5em;
  width: 2em;
}

.customerRects .lines .data{
  position:absolute;
  top: 0.3em;
  bottom: 0;
  left: 3em;
  right: 3em;
}
.customerRects .lines .data .name{
  font-size: 1.1em;
}
.customerRects .lines .data .info{
  font-size: 0.9em;
  margin-top: 0.3em;
  margin-bottom: 0.2em;
}
.customerRects .lines .data .info2{
  font-size: 0.7em;
  color: #999;
}
.addButton{
  margin-bottom: 1em;
  border-left: none;
  border-right: none;
  border-top: 1px solid #eaeaea !important;
  border-bottom: 1px solid #eaeaea !important;
}
</style>
